<template>
    <div>
        <p style="margin-bottom: 0">
            <b>Driver</b>
        </p>
        <div class="driver-info">
            <div class="driver-info-key">Email</div>
            <div><driver-info-value :value="driver_info.email"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Phone</div>
            <div><driver-info-value :value="driver_info.phone"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Carrier</div>
            <div><driver-info-value :value="driver_info.carrier"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Carrier Type</div>
            <div><driver-info-value :value="driver_info.carrier_type"></driver-info-value></div>
        </div>

        <p style="margin: 20px 0 0 0"><b>Experience</b></p>
        <div class="driver-info">
            <div class="driver-info-key">Experience</div>
            <div><driver-info-value :value="driver_info.cdl_xp_text"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Last 3 years experience</div>
            <div><driver-info-value :value="driver_info.cdl_a_months_driven"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">CDL</div>
            <div><driver-info-value :value="driver_info.cdl_licences"></driver-info-value></div>
        </div>

        <p style="margin: 20px 0 0 0"><b>Location</b></p>
        <div class="driver-info">
            <div class="driver-info-key">City</div>
            <div><driver-info-value :value="driver_info.location"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Zip Code</div>
            <div><driver-info-value :value="driver_info.zip_code"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Timezone</div>
            <div>{{ driver_info.timezone }} {{ driver_info.timezone_time }}</div>
        </div>

        <p style="margin: 20px 0 0 0"><b>Driver</b></p>
        <div class="driver-info" v-for="(val, index) in categoriesTexts" :key="index">
            <div class="driver-info-key">{{ val.id }}</div>
            <div>
                <driver-info-value :value="val.value"></driver-info-value>
            </div>
        </div>

        <p style="margin: 20px 0 0 0"><b>Acquisition</b></p>
        <div class="driver-info">
            <div class="driver-info-key">Paid media source</div>
            <div><driver-info-value :value="driver_info.paid_media_source"></driver-info-value></div>
        </div>
        <div class="driver-info">
            <div class="driver-info-key">Source</div>
            <div><driver-info-value :value="driver_info.source"></driver-info-value></div>
        </div>

    </div>
</template>

<script>
import DriverInfoValue from "./driver-detail-driver-info-value";

export default {
        components: {
            DriverInfoValue
        },
        props: [
            'driver_info',
            'lists',
        ],
        computed: {
            categoriesTexts() {
                let driver_preferences = this.driver_info.categories;
                let categories = this.lists.categories;
                let categoryNames = {
                    'driver': 'Job Category',
                    'equipment': 'Equipment experience',
                    'interest_equipment': 'Equipment interest',
                    'route': 'Driving Distance',
                    'teams': 'Teams',
                    'category': 'Specialization',
                };

                let textedCategories = _.map(categories, (value, key) => {
                    return {
                        id: categoryNames[key],
                        value : _.map(value, (value, key) => {
                                return driver_preferences[key] ? value : '';
                            })
                            .filter((r) => r)
                            .join(', ')
                    };
                });
                return textedCategories;
            },
        },
    }
</script>

<style scoped>
    .driver-info {
        display: flex;
    }
    .driver-info-key {
        width: 200px;
    }
</style>